
<div id="mainWrapper" class="container">
    <section id="content-wrapper" class="setUpStoreFront">
        <div>
            <div class="wrap p-0 overflow-x-hidden data-table__wrap">
                <div class="content-container my-order">
                    <section class="data-table">
                        <header class="data-table__header col">
                            <span class="back_to_invoice">
                                <a href="javascript:void(0)" class="back" routerLink="/store">
                                    <img src="./images/delivery-wallet/maki_arrow.svg" alt="back" loading="lazy">
                                    <ng-container i18n="@@wallet.back">Back</ng-container>
                                </a>
                            </span>
                            <h2 class="page-heading tab-content-header active" id="products-content-header">
                                <img src="./images/delivery-wallet/maki_arrow.svg" alt="back" loading="lazy">
                                <ng-container i18n="@@wallet.delivery_wallet">Delivery Wallet</ng-container>
                            </h2>
                        </header>
                        <div class="content-delivery">
                            <app-banner [walletStatus]="walletStatus"></app-banner>

                            <div class="box balance">
                                <div class="title" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                                    <h2 i18n="@@wallet.your_balance">Your Balance</h2>

                                    <div class="switch-wrapper" style="display: flex; align-items: center;">
                                        <div class="switch">
                                            <input type="checkbox" id="auto-renew-wallet" [(ngModel)]="isAutoRenewEnabled" (change)="autoRenewUpdate(isAutoRenewEnabled)">
                                            <span class="slider round"></span>
                                        </div>
                                        <h2><strong i18n="@@wallet.auto_renew">Auto Renew</strong></h2>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="row inner">
                                        <div class="current">
                                            <span class="value">
                                                <img *ngIf="currency == 'SAR'" loading="lazy"  style="width: 40px;" src='/images/icons/sar_symbol_black.svg'>
                                                {{ balance | number:'.2' }} <span *ngIf="currency != 'SAR'">{{ currency }}</span>
                                                <!-- <?php echo languageDetector('0 SAR', 'SAR 0'); ?> -->
                                            </span>
                                            <span class="additional">
                                                Minimum Balance:<img  style="width: 15px;" src='/images/icons/sar_symbol_black.svg' loading="lazy"> 25
                                                <!-- <?php echo languageDetector('الحد الأدنى للرصيد: 50 ريال سعودي', 'Minimum Balance: 50 SAR'); ?> -->
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row inner">
                                        <button class="btn md" id="topUp2" (click)="openTopUpModal()">
                                            <ng-container i18n="@@wallet.top_up_your_wallet">Top-up your wallet</ng-container>
                                        </button>
                                        <button class="btn md white" *ngIf="balance > 10" id="withdraw" (click)="openWithdrawModal()">
                                            <ng-container i18n="@@wallet.withdraw_balance">Withdraw balance</ng-container>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="box payment" *ngIf="0">
                                <div class="row">
                                    <div class="title">
                                        <h2> Payment Info </h2>
                                        <button class="btn edit">
                                            <img src="./images/delivery-wallet/edit.svg" alt="edit" loading="lazy">
                                        </button>
                                    </div>
                                    <button class="btn lg white" id="topUpAuto">
                                        Switch to automatic top-up
                                    </button>
                                </div>
                                <div class="payment-row">
                                    <div class="item">
                                        <img
                                            src="./images/delivery-wallet/VISA_logo.svg"
                                            alt="payment" loading="lazy">
                                        <span>**** **** **** 2397</span>
                                    </div>
                                    <div class="item">
                                        <img
                                            src="./images/delivery-wallet/stc.svg"
                                            alt="payment" loading="lazy">
                                        <span>ID: 243655478</span>
                                    </div>
                                    <button class="btn lg white"
                                        id="topUpAuto2">
                                        Switch to automatic top-up
                                    </button>
                                </div>
                            </div>

                            <div class="box history" *ngIf="transactions?.length > 0;">
                                <h2 i18n="@@wallet.history">History</h2>
                                <div class="table-widget">
                                    <table>
                                        <tr>
                                            <th i18n="@@common.status">Status</th>
                                            <th i18n="@@ts.date">Date</th>
                                            <th i18n="@@invoices.payment_method">Payment method</th>
                                            <th i18n="@@ts.common.fees">Fees</th>
                                            <th i18n="@@ts.common.amount">Amount</th>
                                        </tr>
                                        <tr *ngFor="let transaction of transactions">
                                            <td class="">
                                                <div class="order_status" [ngClass]="transaction.status == 'CAPTURED' ? 'order_new' : (transaction.status == 'INITIATED' ? 'order_complete' : 'order_declined')">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                        <circle cx="4" cy="4" r="4" fill="#18F121"></circle>
                                                    </svg>
                                                    {{ transaction.status }}
                                                </div>
                                            </td>
                                            <td>{{ transaction.transaction_date | date:'dd.MM.yyyy' }}</td>
                                            <td>
                                                <div class="row">
                                                    <img *ngIf="transaction?.card_brand" loading="lazy" src="./images/delivery-wallet/{{transaction.card_brand}}_logo.svg" alt="payment">
                                                    <span>{{ transaction?.card ? transaction?.card : '-' }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <img *ngIf="transaction.currency == 'SAR'" style="width: 15px;" loading="lazy" src='/images/icons/sar_symbol_black.svg'> <span *ngIf="transaction?.fee !== null; else zeroTemplate">{{ transaction.fee | number:'.2' }} </span> <ng-template #zeroTemplate>0</ng-template> <span *ngIf="transaction.currency != 'SAR'">{{ transaction.currency }} </span>
                                            </td>
                                            <td><img *ngIf="transaction.currency == 'SAR'" style="width: 15px;" loading="lazy" src='/images/icons/sar_symbol_black.svg'> {{ transaction.amount | number:'.2'  }} <span *ngIf="transaction.currency != 'SAR'">{{ transaction.currency }} </span></td>
                                        </tr>
                                    </table>

                                    <!-- paginator  -->
                                    <ng-container *ngIf="totalPages > 1">
                                        <div class="pagination_wrapper">
                                            <div class="controls">
                                                <div class="showing_results">
                                                    <div class="select_wrapper">
                                                        <ng-container i18n="@@show">Show</ng-container>
                                                        <select class="select-link tab-links-select nice-select" #perPageCount id="tab-links-select" nice-select (change)="onPerPageChange(perPageCount.value)">
                                                            <option value="5">5</option>
                                                            <option value="10">10</option>
                                                            <option value="15">15</option>
                                                        </select>
                                                        <ng-container i18n="@@items">items</ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <nav pagination-template aria-label="...">
                                                <ul class="pagination justify-content-center">
                                                    <li class="page-item">
                                                        <a class="page-link prev" tabindex="-1" (click)="prevPage()">
                                                            <svg width="7.5" height="30" style="padding-top: 7px;">
                                                                <path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                            </svg>
                                                        </a>
                                                    </li>
                                                    <li *ngFor="let page of getVisiblePages()" class="page-item" [class.active]="currentPage === page">
                                                        <a *ngIf="currentPage !== page" (click)="goToPage(page)" class="page-link">
                                                            <span>{{ page }}</span>
                                                        </a>
                                                        <a *ngIf="currentPage === page" class="page-link">
                                                            {{ page }}
                                                            <span class="sr-only">(current)</span>
                                                        </a>
                                                    </li>
                                                    <li class="page-item">
                                                        <a (click)="nextPage()" class="page-link next">
                                                            <svg width="7.5" height="30" style="padding-top: 7px;">
                                                                <path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                            </svg>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </nav> -->
                                            <nav pagination-template aria-label="Pagination Navigation">
                                                <ul class="pagination justify-content-center">
                                                    <!-- Previous -->
                                                    <li class="page-item" [class.disabled]="currentPage === 1">
                                                        <a class="page-link prev" *ngIf="currentPage !== 1" (click)="prevPage()">
                                                            <svg width="7.5" height="30" style="padding-top: 7px;">
                                                                <path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                            </svg>
                                                        </a>
                                                    </li>
                                                
                                                    <!-- Page Numbers (with ellipses) -->
                                                    <li *ngFor="let page of paginationRange" class="page-item" [class.active]="page === currentPage"
                                                        [class.disabled]="page === '...'">
                                                        <a *ngIf="page !== '...'" (click)="goToPage(page)" class="page-link">
                                                            {{ page }}
                                                        </a>
                                                        <span *ngIf="page === '...'" class="page-link">…</span>
                                                    </li>
                                                
                                                    <!-- Next -->
                                                    <li class="page-item" [class.disabled]="currentPage === totalPages">
                                                        <a (click)="nextPage()" *ngIf="currentPage !== totalPages" class="page-link next">
                                                            <svg width="7.5" height="30" style="padding-top: 7px;">
                                                                <path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                            </svg>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </nav>

                                        </div>
                                    </ng-container>
                                    <!-- paginator  -->
                                </div>

                                <div class="history-items">
                                    <div class="item" *ngFor="let transaction of transactions">
                                        <div class="item-row">
                                            <span class="item-name">
                                                {{ transaction.status }}
                                                <!-- <?php echo languageDetector('التعبئة اليدوية', 'Manual top-up'); ?> -->
                                            </span>
                                            <span
                                                class="item-date">{{ transaction.transaction_date | date:'dd.MM.yyyy' }}</span>
                                        </div>
                                        <div class="item-row">
                                            <div class="payway">
                                                <img *ngIf="transaction?.card_brand" loading="lazy" src="./images/delivery-wallet/{{transaction.card_brand}}_logo.svg" alt="payment">
                                                <span>{{ transaction?.card ? transaction?.card : '-' }}</span>
                                            </div>
                                            <span class="value">
                                                <img *ngIf="transaction.currency == 'SAR'" loading="lazy" style="width: 15px;" src='/images/icons/sar_symbol_black.svg'>
                                                {{ transaction.amount | number:'.2'  }}
                                                <span *ngIf="transaction.currency != 'SAR'">
                                                    {{ transaction.currency }}
                                                </span>
                                                <!-- <?php echo languageDetector('SAR 50', '50 SAR'); ?> -->
                                            </span>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="totalPages > 1">
                                        <div class="pagination_wrapper">
                                            <div class="controls">
                                                <div class="showing_results">
                                                    <div class="select_wrapper">
                                                        <ng-container i18n="@@show">Show</ng-container>
                                                        <select class="select-link tab-links-select nice-select" #perPageCount id="tab-links-select" nice-select (change)="onPerPageChange(perPageCount.value)">
                                                            <option value="5">5</option>
                                                            <option value="10">10</option>
                                                            <option value="15">15</option>
                                                        </select>
                                                        <ng-container i18n="@@items">items</ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <nav pagination-template aria-label="...">
                                                <ul class="pagination justify-content-center">
                                                    <li class="page-item" [class.disabled]="currentPage === 1">
                                                        <a class="page-link prev" tabindex="-1" (click)="prevPage()" [class.disabled]="currentPage === 1">
                                                            <svg width="7.5" height="30" style="padding-top: 7px;">
                                                                <path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                            </svg>
                                                        </a>
                                                    </li>
                                                    <li *ngFor="let page of pages" class="page-item" [class.active]="currentPage === page">
                                                        <a *ngIf="currentPage !== page" (click)="goToPage(page)" class="page-link">
                                                            <span>{{ page }}</span>
                                                        </a>
                                                        <a *ngIf="currentPage === page" class="page-link">
                                                            {{ page }}
                                                            <span class="sr-only">(current)</span>
                                                        </a>
                                                    </li>
                                                    <li class="page-item" [class.disabled]="currentPage === totalPages">
                                                        <a (click)="nextPage()" class="page-link next" [class.disabled]="currentPage === totalPages">
                                                            <svg width="7.5" height="30" style="padding-top: 7px;">
                                                                <path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                            </svg>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </nav> -->
                                            <nav pagination-template aria-label="Pagination Navigation">
                                                <ul class="pagination justify-content-center">
                                                    <!-- Previous -->
                                                    <li class="page-item" [class.disabled]="currentPage === 1">
                                                        <a class="page-link prev" *ngIf="currentPage !== 1" (click)="prevPage()">
                                                            <svg width="7.5" height="30" style="padding-top: 7px;">
                                                                <path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                            </svg>
                                                        </a>
                                                    </li>
                                                
                                                    <!-- Page Numbers (with ellipses) -->
                                                    <li *ngFor="let page of paginationRange" class="page-item" [class.active]="page === currentPage" [class.disabled]="page === '...'">
                                                        <a *ngIf="page !== '...'" (click)="goToPage(page)" class="page-link">{{ page }}</a>
                                                        <span *ngIf="page === '...'" class="page-link">…</span>
                                                    </li>
                                                
                                                    <!-- Next -->
                                                    <li class="page-item" [class.disabled]="currentPage === totalPages">
                                                        <a (click)="nextPage()" *ngIf="currentPage !== totalPages" class="page-link next">
                                                            <svg width="7.5" height="30" style="padding-top: 7px;">
                                                                <path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                            </svg>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <!-- end content-container -->
            </div>

            <app-topup [savedCards]="savedCards"></app-topup>
            <app-withdraw></app-withdraw>
        </div>
    </section>
    <!-- end content-wrapper -->
</div>
